export function copyToClipboard({ text }: { text: string }) {
  if (navigator?.clipboard) {
    navigator.clipboard.writeText(text);
    return;
  }
  if (navigator?.share) {
    navigator.share({
      text: text,
    });
    return;
  }
}

export function hashCode(str: string): number {
  let hash = 0,
    i = 0;
  const len = str.length;
  while (i < len) {
    hash = ((hash << 5) - hash + str.charCodeAt(i++)) << 0;
  }
  return hash + 2147483647 + 1;
}

export function isValidUrl(url: string) {
  try {
    new URL(url);
    return true;
  } catch (e) {
    return false;
  }
}
